<template>
  <div class="pharmacyrecord">
    <el-row>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px;margin-top: 5px">
        <el-form-item label="老人姓名" style="margin-left: 10px">
          <el-input
            v-model.trim="filters.oldmanName"
            placeholder="请输入姓名"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage"
          />
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <!--表格内容栏-->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          align="center"
        ></el-table-column>
        
        <el-table-column
          prop="completeTime"
          label="服务时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
        >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            v-if="scope.row.status == 0"
            icon="el-icon-search"
            @click="handleDelete(scope.$index, scope.row)"
            >详情</el-button>
          <el-button
            type="warning"
            size="mini"
            icon="el-icon-umbrella"
            v-if="scope.row.status == 1"
            @click="handleDelete(scope.$index, scope.row)"
            >提醒</el-button>
        </template>
      </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      class="fenye"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="changepage"
      align="center"
    ></el-pagination>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
export default {
  name: "MedicalPlanList",
  components: { KtButton },
  data() {
    return {
      loading: true,
      size: "medium", //按钮的尺寸
      tableData: [], //表格数据
      filters: {
        oldmanName: "",
      },
      total: 0, //分页总数
      pageNum: 1,
      pageSize: 10,
    };
  },
  methods: {
    //翻页
    changepage(val) {
      this.pageNum = val;
      this.findPage();
    },
    //enter键查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage();
      }
    },
    //查询列表
    findPage(data) {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldmanName: this.filters.oldmanName,
        nursingGroupId: sessionStorage.getItem("nursingGroupId"),
      };
      this.tableData = [
       
      ];
      this.total = 18;
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  created() {},
  mounted() {
    this.findPage();
  },
};
</script>
<style lang="scss" scoped>
.pharmacyrecord {
  width: 100%;
  background: #fefefe;
}
.fenye {
  padding: 30px 0;background: #fff;
}
</style>
